/**
 * SIMPS Drink Lab — categoryStyles.js
 * Visual treatment for the 8 top-level drink-type category cards.
 *
 * `icon` is a TEMPORARY placeholder (emoji in a colour block) standing in
 * for real drink photography — swap `icon` for a real `imageUrl` per
 * category once artwork is ready; renderCategoryGrid() in drinkLabApp.js
 * already prefers `imageUrl` over `icon` if present, so no JS changes will
 * be needed to swap them in later.
 *
 * `bg` = light card background tint, `accent` = bold colour for the
 * image-placeholder block. Keyed by the same drinkType value used in
 * questions.js's `set.drinkType`.
 *
 * `dirty_soda` (added 2026-08-11) is not a quiz drinkType — the quiz never
 * asks for it directly — it's used only by Search by Flavour's result
 * filter chips, to give the Dirty Soda Lab recipes (DL-035–044, the ones
 * with both custom_soda AND creamy compatibility) their own visual
 * identity distinct from plain Custom Soda or Creamy.
 */
window.DrinkLab = window.DrinkLab || {};

window.DrinkLab.CATEGORY_STYLES = {
  coffee: {
    icon: '☕',
    bg: '#F1E4D8',
    accent: '#6F4E37',
    copy: 'Coffee, tea, chai & matcha.'
  },
  custom_soda: {
    icon: '🥤',
    bg: '#FCE1E6',
    accent: '#E23F62',
    copy: 'Build your own fizzy creation.'
  },
  dirty_soda: {
    icon: '🧋',
    bg: '#FCE6EF',
    accent: '#B23A73',
    copy: 'Custom soda meets cream.'
  },
  lemonade: {
    icon: '🍋',
    bg: '#FCF3D2',
    accent: '#D9A916',
    copy: 'Classic, bright, refreshing.'
  },
  sparkling: {
    icon: '🧧',
    bg: '#DFF3F6',
    accent: '#3AA8BF',
    copy: 'Light, crisp, effervescent.'
  },
  creamy: {
    icon: '🥛',
    bg: '#F5EBE0',
    accent: '#B98A5D',
    copy: 'Smooth, rich, indulgent.'
  },
  iced_tea: {
    icon: '🧊',
    bg: '#F1E7D4',
    accent: '#A9712F',
    copy: 'Cool, steeped, classic.'
  },
  mocktail: {
    icon: '🍹',
    bg: '#EDE3FA',
    accent: '#8358C9',
    copy: 'All the craft, none of the alcohol.'
  },
  cocktail: {
    icon: '🍸',
    bg: '#FBEAD2',
    accent: '#C4801B',
    copy: 'The full bar-cart experience.'
  }
};